const mimeInfo = [
  {
    mime: "application/msword",
    type: "word",
    ext: "doc"
  },
  {
    mime:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    type: "word",
    ext: "docx"
  },
  {
    mime: "application/vnd.ms-excel",
    type: "excel",
    ext: "xls"
  },
  {
    mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    type: "excel",
    ext: "xlsx"
  },
  {
    mime: "text/plain",
    type: "txt",
    ext: "txt"
  },
  {
    mime: "image/gif",
    type: "image",
    ext: "gif"
  },
  {
    mime: "image/jpeg",
    type: "image",
    ext: "jpg"
  },
  {
    mime: "image/bmp",
    type: "image",
    ext: "bmp"
  },
  {
    mime: "image/png",
    type: "image",
    ext: "png"
  }
];

// 获取文件信息  type,ext
export const getFileDetailInfo = mime => {
  return mimeInfo.find(item => {
    return item.mime === mime;
  });
};
